import { render } from "./AlertShareRequest.vue?vue&type=template&id=704ae330"
import script from "./AlertShareRequest.vue?vue&type=script&lang=js"
export * from "./AlertShareRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__